import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { HewanKurbanCampaignCard } from './HewanKurbanCampaignCard';
import { HewanKurbanCampaignEditDialog } from './hewan-kurban-edit-dialog/HewanKurbanCampaignEditDialog';
import { HewanKurbanCampaignUIProvider } from './HewanKurbanCampaignUIContext';
import { PrivateRoute } from "../../../../../PrivateRoute";
import { RoleChecker } from '../../../../../RoleChecker';


export function HewanKurbanCampaignPage({ history }) {

    const hewanKurbanCampaignUIEvents = {
        newHewanKurbanCampaignButtonClick: () => {
            history.push('/kurban/campaign-hewan-kurban/new');
        },
        openEditHewanKurbanCampaignPage: (id) => {
            history.push(`/kurban/campaign-hewan-kurban/${id}/edit`);
        },
    };

    return (
        <HewanKurbanCampaignUIProvider hewanKurbanCampaignUIEvents={hewanKurbanCampaignUIEvents}>

            <Route path="/kurban/campaign-hewan-kurban/new">
                {({ history, match }) => (
                    <HewanKurbanCampaignEditDialog
                        show={match != null}
                        onHide={() => {
                            history.push('/kurban/campaign-hewan-kurban/');
                        }}
                    />
                )}
            </Route>

            <Route path="/kurban/campaign-hewan-kurban/:id/edit">
                {({ history, match }) => (
                    <HewanKurbanCampaignEditDialog
                        show={match != null}
                        id={match && match.params.id}
                        onHide={() => {
                            history.push('/kurban/campaign-hewan-kurban/');
                        }}
                    />
                )}
            </Route>



            <HewanKurbanCampaignCard />
        </HewanKurbanCampaignUIProvider>
    );
}
